class CollectionPagination extends HTMLElement {
    constructor() {
        super();
        this.bindEvents();
    }

    bindEvents() {
        const loadMoreButton = this.querySelector(".collection__pagination-more span");
        loadMoreButton?.addEventListener("click", this.onLoadMoreClick.bind(this));
    }

    onLoadMoreClick(event: Event) {
        const targetElement = event.currentTarget as HTMLElement;
        const nexPageUrl = targetElement?.getAttribute("data-next-url") as string;
        const sectionId = targetElement?.getAttribute("data-section-id") as string;
        this.fetchCollectionContent(nexPageUrl, sectionId);
    }

    fetchCollectionContent(url: string, sectionId: any) {
        const collectionMainContainer = document.querySelector("collection-main");
        collectionMainContainer?.classList.add("loading");

        fetch(`${url}&sections=${sectionId}`)
        .then((response) => response.json())
        .then((responseText) => {
            collectionMainContainer?.classList.remove("loading");
            this.renderCollectionContent(responseText[sectionId]);
            this.renderPaginationContent(responseText[sectionId]);
        });
    }

    renderCollectionContent(html: string) {
        const collectionGridElement = document.querySelector("collection-grid");
        const collectionGridDom = this.getSectionInnerHTML(html) as any;
        const products = collectionGridDom.querySelectorAll("collection-grid > div");

        products.forEach((product: HTMLElement) => {
            collectionGridElement?.appendChild(product);
        });

  
        // window.swymcsWishlistFunctions.init()
        //   window.SwymCallbacks = [];
        // window.SwymCallbacks.push(window.swymcsWishlistFunctions.init);
        //   console.log(' window.SwymCallbacks', window.SwymCallbacks)
    }    

    renderPaginationContent(html: string) {
        const collectionPaginationElementTop = document.querySelector("collection-pagination.top") as HTMLElement;
        const outerHTMLTop = this.getSectionInnerHTML(html).querySelector("collection-pagination.top")?.outerHTML as string;

        const collectionPaginationElementBottom = document.querySelector("collection-pagination.bottom") as HTMLElement;
        const outerHTMLBottom = this.getSectionInnerHTML(html).querySelector("collection-pagination.bottom")?.outerHTML as string;

        if(collectionPaginationElementTop) {
            collectionPaginationElementTop.outerHTML = outerHTMLTop;
        }

        if(collectionPaginationElementBottom) {
            collectionPaginationElementBottom.outerHTML = outerHTMLBottom;
        }
    }


    getSectionInnerHTML(html: string) {
        return new DOMParser().parseFromString(html, 'text/html');
    }
}


customElements.define("collection-pagination", CollectionPagination);